import axios from 'axios'

export const request =  axios.create({
    baseURL: 'cloudapis',
    timeout: 50000
})



// WEBPACK FOOTER //
// ./src/api/index.js